import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUserStore } from '../../stores/userStore';
import queryClient from '../../queryClient';
import ActionDialog from '../../components/dialog/ActionDialog';
import PageLayout from '../../components/layout/PageLayout';
import { Typography } from '@mui/material';
import { safeRedirectPath } from '../../utils/safeRedirectPath';

const LoginSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const fetchUser = useUserStore((state) => state.fetchUser);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) {
      return;
    }

    const token = searchParams.get('token');
    const isActive = searchParams.get('isActive');
    const redirectUrl = safeRedirectPath(searchParams.get('redirectUrl'));

    if (isActive === 'false') {
      setInfoDialogOpen(true);
      hasProcessed.current = true;
    } else if (token) {
      localStorage.setItem('POSTPOP_AUTH_TOKEN', token);
      queryClient.clear();
      fetchUser();
      hasProcessed.current = true;
      navigate(redirectUrl, { replace: true });
    } else {
      // 토큰이 없는 비정상적인 접근
      hasProcessed.current = true;
      navigate('/login', { replace: true });
    }
  }, [searchParams, navigate, fetchUser]);

  const handleCloseDialog = () => {
    setInfoDialogOpen(false);
    navigate('/login', { replace: true });
  };

  return (
    <PageLayout>
      <ActionDialog
        open={infoDialogOpen}
        onClose={handleCloseDialog}
        onConfirm={handleCloseDialog}
        showCancel={false}
      >
        <Typography sx={{ textAlign: 'center', lineHeight: 1.5 }}>
          관리자에 의해 활동이 정지되었습니다
          <br />더 자세한 내용은 이메일을 확인해주세요.
        </Typography>
      </ActionDialog>
    </PageLayout>
  );
};

export default LoginSuccess;
